var StaticContent = function(){

    'use strict';

    var $ = jQuery;
    var instances = [];


    function onReady() {
        $('.module.static-content').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        var $view = view,
            id = $view.data('id');

        var instance = {
            init: function () {
                $(window).resize(resize);
                equalizeCols();
                checkCenteredImages();
            }
        };

        function checkCenteredImages(){
            $view.find('.positionable').each(function(key, value){
                if($(this).attr('data-vertical') === 'middle'){
                    $(this).css('margin-top', ($(this).find('img').innerHeight() / 2) * -1);
                }
            });
        }

        function equalizeCols(){
            $view.find('.static-content .col .content-wrapper').css('min-height', '');
            var colHeight = getBigestElement($view.find('.static-content .col'), '.content-wrapper');
            $view.find('.static-content .col .content-wrapper').css('min-height', colHeight);
        }

        function getBigestElement($parent, element){
            var minimumOld, minimum;

            minimumOld = 0;
            $parent.each(function(key, child){
                if(element){
                    minimum = $(child).find(element).outerHeight(); 
                }else{
                    minimum = $(child).outerHeight(); 
                }
                if(minimum > minimumOld){
                    minimumOld = minimum;
                }
            });

            return minimumOld;
        }

        function resize(){
            equalizeCols();
            checkCenteredImages();
        }

        instance.init();
        return instance;
    }

    $(onReady);

}

StaticContent();
